import { ref } from 'vue';

export function useSwitcher() {
  const isOn = ref(false);

  const on = () => (isOn.value = true);

  const off = () => (isOn.value = false);

  const toggle = () => (isOn.value = !isOn.value);

  return {
    isOn,
    on,
    off,
    toggle
  };
}